import React, { useState } from 'react'
import { useFilter } from '../../forms/hocs/filter.context.hoc'
import { StyledSearchFilterSelectContainer, StyledCheckboxForm } from './search-filters-checkbox.styles'
import { SearchFiltersCheckbox } from './search-filters-checkbox'
import { ShowMoreOptions } from './show-more-options'
import { FilterComponentProp } from '../../forms/hocs/types'

const MAX_INITIAL_CHECKBOX_OPTIONS = 8

export const SearchFiltersCheckboxes = ({ moreOptionsLabel }: FilterComponentProp) => {
    const { options, selected } = useFilter()
    const hasMoreOptions = options.length > MAX_INITIAL_CHECKBOX_OPTIONS
    const shouldShowMoreOptions = selected.some(
        (selectedOption) =>
            options.findIndex((option) => option.value == selectedOption) >= MAX_INITIAL_CHECKBOX_OPTIONS
    )
    const [showMoreOptions, setShowMoreOptions] = useState(shouldShowMoreOptions)
    const optionsToShow = showMoreOptions ? options : options.slice(0, MAX_INITIAL_CHECKBOX_OPTIONS)

    return (
        <StyledCheckboxForm>
            <StyledSearchFilterSelectContainer>
                {optionsToShow.map((option) => (
                    <SearchFiltersCheckbox key={option.label} option={option} />
                ))}

                {hasMoreOptions && !showMoreOptions ? (
                    <ShowMoreOptions text={moreOptionsLabel} callback={setShowMoreOptions} />
                ) : null}
            </StyledSearchFilterSelectContainer>
        </StyledCheckboxForm>
    )
}
